import { render, staticRenderFns } from "./CompaniesUpload.vue?vue&type=template&id=6c3b4cfe&scoped=true&"
import script from "./CompaniesUpload.vue?vue&type=script&lang=ts&"
export * from "./CompaniesUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3b4cfe",
  null
  
)

export default component.exports